/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightExchangeAuthenticationAction
 */
export interface FlightExchangeAuthenticationAction {
  /**
   *
   * @type {string}
   * @memberof FlightExchangeAuthenticationAction
   */
  method: FlightExchangeAuthenticationActionMethodEnum;
  /**
   * Ephemeral challenge credential for the provider UI adapter. Never persist or log.
   * @type {string}
   * @memberof FlightExchangeAuthenticationAction
   */
  clientToken: string;
}

/**
 * @export
 */
export const FlightExchangeAuthenticationActionMethodEnum = {
  ThreeDSecure: "three_d_secure",
} as const;
export type FlightExchangeAuthenticationActionMethodEnum =
  (typeof FlightExchangeAuthenticationActionMethodEnum)[keyof typeof FlightExchangeAuthenticationActionMethodEnum];

/**
 * Check if a given object implements the FlightExchangeAuthenticationAction interface.
 */
export function instanceOfFlightExchangeAuthenticationAction(
  value: object
): value is FlightExchangeAuthenticationAction {
  if (!("method" in value) || value["method"] === undefined) return false;
  if (!("clientToken" in value) || value["clientToken"] === undefined)
    return false;
  return true;
}

export function FlightExchangeAuthenticationActionFromJSON(
  json: any
): FlightExchangeAuthenticationAction {
  return FlightExchangeAuthenticationActionFromJSONTyped(json, false);
}

export function FlightExchangeAuthenticationActionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeAuthenticationAction {
  if (json == null) {
    return json;
  }
  return {
    method: json["method"],
    clientToken: json["client_token"],
  };
}

export function FlightExchangeAuthenticationActionToJSON(
  json: any
): FlightExchangeAuthenticationAction {
  return FlightExchangeAuthenticationActionToJSONTyped(json, false);
}

export function FlightExchangeAuthenticationActionToJSONTyped(
  value?: FlightExchangeAuthenticationAction | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    method: value["method"],
    client_token: value["clientToken"],
  };
}
